import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './bin-path-name';
import '../../common/bn-loading';
import '../../common/bn-action';
import '../../work-orders/parts/work-order-card';
import './device-removal-summary';

class BinDelete extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      .cannot-delete {
        text-align: center;
        color: var(--blue-60);
      }
      .work-orders {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      }
      h4 {
        margin-top: 1.5em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    const confirmDelete = this.entity.hasActionByName('confirm-delete');
    const device = this.entity.getSubEntityByClass('device');
    const workOrders = this.entity.getSubEntitiesByClass('work-order');
    const binHref = this.getHref('up');

    return html`
      ${renderIf(confirmDelete, html`
        <bn-action
          .href="${this.href}"
          actionname="confirm-delete"
          successtext="Bin has been deleted. Redirecting to bin list."
          buttonstyle='outlinedError'
        >
          <span slot="header">
            <h3>Delete Bin</h3>
            <bin-path-name .href="${binHref}"  ></bin-path-name>
          </span>
        </bn-action>
      `)}

      ${renderIf(!confirmDelete, html`
        <p class="cannot-delete">This bin cannot currently be deleted.<br/>Please contact your BinSentry representative to uninstall any devices or cancel any workorders.</p>
        ${this._renderDevice(device)}
        ${this._renderWorkOrders(workOrders)}
      `)}
    `;
  }

  _renderDevice(device) {
    if (!device) {
      return html``;
    }

    return html`
      <h4>Installed Device</h4>
      <device-removal-summary
        .href="${device.href}"
        @response="${(e) => e.stopPropagation()}"
        @error="${(e) => alert(e.error)}"
      ></device-removal-summary>
    `;
  }

  _renderWorkOrders(workOrders) {
    if (!workOrders || workOrders.length === 0) {
      return html``;
    }

    return html`
      <h4>Incomplete Work Orders</h4>
      <div class="work-orders">
        ${workOrders.map((wo) => html`
          <work-order-card
            .href="${wo.href}"
            linkpath="/work-orders/show"
          ></work-order-card>
        `)}
      </div>
    `;
  }
}

window.customElements.define('bin-delete', BinDelete);
